import React from 'react';
import {BaseModal} from '../comun/Index';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state={}
  }

  componentDidMount(){}

  titulo(tipo){
    if (tipo === 0){
      return("Existe persona");
    } else {
      return("No existe persona");
    }
  }

  botones(tipo){
    if (tipo === 0){
      return (
        [
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
          {titulo:"Crear demanda", backgroundColor:'#00a5e5', onClick: () => this.props.opcion(0)}
        ]
      )
    } else  {
      return (
        [
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
          {titulo:"Crear persona", backgroundColor:'#00a5e5', onClick: () => this.props.opcion(1)}
        ]
      )
    }
  }

  render(){
    const {tipoModal} = this.props;
    return(
      <BaseModal
        titulo={this.titulo(tipoModal)}
        loading={false}
        botonera={this.botones(tipoModal)}
      >
        <h4 style={{textAlign:'center'}}>¿Que accion desea tomar?</h4>
      </BaseModal>
    );
  }
}

export default Modal;
